"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identifyUserWithLogRocket = identifyUserWithLogRocket;
exports.mapUserContextToLogRocketIdentify = mapUserContextToLogRocketIdentify;
exports.continueExistingLogRocketSession = exports.initLogRocketSession = exports.requestSanitizer = exports.keySanitizer = exports.default = exports.allowRequests = exports.headerSanitizer = void 0;

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

var _environment = _interopRequireDefault(require("../environment"));

var _storage = require("../storage");

var _logRocketTrack = require("./logRocketTrack");

var _logRocketCookieUtils = require("./logRocketCookieUtils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getAppId = function getAppId(environment) {
  var projectName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'production';
  var ids = {
    production: "cl9xsz/zola-".concat(projectName),
    staging: 'cl9xsz/zola-staging',
    development: 'cl9xsz/zola-development'
  };
  return ids[environment];
};

var DENY_HEADERS = ['Cognito-Id-Token', 'Cognito-Refresh-Token']; // The actual LR request type def is locked in its own namespace :(

var headerSanitizer = function headerSanitizer(request) {
  DENY_HEADERS.forEach(function (header) {
    if (request !== null && request !== void 0 && request.headers[header]) {
      request.headers[header] = undefined;
    }
  });
  return request;
};
/**
 * Only requests with x-record-request-body get their body sent to LogRocket
 *
 * @param {*} request
 */


exports.headerSanitizer = headerSanitizer;

var allowRequests = function allowRequests(request) {
  if (!request) return null;
  var headers = request.headers;

  if (headers && headers['x-record-request-body']) {
    return request;
  }

  return _objectSpread(_objectSpread({}, request), {}, {
    body: undefined
  });
}; // eslint-disable-next-line @typescript-eslint/ban-types


exports.allowRequests = allowRequests;

function removeSensitiveKeys(body) {
  if (!body) return undefined;
  var parsed = body;

  if (typeof body === 'string') {
    parsed = JSON.parse(body); // The request body might be a string or JSON object
  }

  var _parsed = parsed,
      email = _parsed.email,
      password = _parsed.password,
      newBody = _objectWithoutProperties(_parsed, ["email", "password"]);

  Object.keys(newBody).forEach(function (key) {
    if (_typeof(newBody[key]) === 'object') {
      newBody[key] = removeSensitiveKeys(newBody[key]);
    }
  });
  return JSON.stringify(newBody);
}

var _default = removeSensitiveKeys;
exports.default = _default;

var keySanitizer = function keySanitizer(request) {
  if (!request) return null;
  var body = null;

  try {
    if (typeof request.body === 'string') {
      body = JSON.parse(request.body); // The request body might be a string or JSON object
    }
  } catch (error) {} // eslint-disable-line no-empty


  return _objectSpread(_objectSpread({}, request), {}, {
    body: removeSensitiveKeys(body)
  });
};

exports.keySanitizer = keySanitizer;

var requestSanitizer = function requestSanitizer(request) {
  return keySanitizer(headerSanitizer(allowRequests(request)));
};

exports.requestSanitizer = requestSanitizer;

var initLogRocketSession = function initLogRocketSession(condition) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var environment = (0, _environment.default)();
  var initEventName = options.initEventName,
      projectName = options.projectName,
      devOverride = options.devOverride;
  var isOfficeIp = (0, _storage.getCookie)('zolaOfficeIp') === 'true';
  var isBlockedUserAgent = window.navigator.userAgent.indexOf('BingPreview') > -1 || window.navigator.userAgent.indexOf('HeadlessChrome') > -1 || window.navigator.userAgent.indexOf('TreoWorker') > -1;
  var allowLogrocket = !isOfficeIp && !isBlockedUserAgent && environment === 'production' || devOverride;
  var appId = getAppId(environment);
  var rootHostname = environment === 'development' ? undefined : 'zola.com';
  var shouldStartSession = Boolean(condition && appId && allowLogrocket); // Disabled to lower number of Segment events, Re-enable for a breakdown of logrocket events by name in GA.
  // trackGoogleAnalyticsEvent(`LogRocket ${shouldStartSession ? 'Initialized' : 'Not Initialized'}`, {
  //   category: getCookie(LOG_ROCKET_COOKIE) ? 'existing' : 'new',
  //   label: initEventName,
  // });

  if (shouldStartSession) {
    (0, _logRocketCookieUtils.setLogRocketCookie)(projectName || 'production');

    if (initEventName) {
      (0, _logRocketTrack.logRocketTrack)(initEventName);
    }

    if (window !== undefined && window.LogRocket) {
      window.LogRocket.init(appId, {
        network: {
          requestSanitizer: requestSanitizer
        },
        rootHostname: rootHostname
      });
    }
  }
};

exports.initLogRocketSession = initLogRocketSession;

var continueExistingLogRocketSession = function continueExistingLogRocketSession(devOverride) {
  var currentLogRocketProject = (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE);

  if (currentLogRocketProject) {
    initLogRocketSession(true, {
      projectName: currentLogRocketProject,
      devOverride: devOverride
    });
  }
};

exports.continueExistingLogRocketSession = continueExistingLogRocketSession;

function identifyUserWithLogRocket(_ref) {
  var uid = _ref.uid,
      name = _ref.name,
      email = _ref.email,
      _ref$traits = _ref.traits,
      traits = _ref$traits === void 0 ? {} : _ref$traits;

  var traitsFinal = _objectSpread({
    name: name,
    email: email
  }, traits);

  var isActiveSession = Boolean((0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE));

  if (uid && isActiveSession) {
    if (window !== undefined && window.LogRocket) {
      window.LogRocket.identify(uid, traitsFinal);
    }
  }
}

function mapUserContextToLogRocketIdentify(userContext, traits) {
  var objectId = userContext.object_id,
      email = userContext.email,
      firstName = userContext.first_name,
      lastName = userContext.last_name;
  var name = firstName && lastName ? "".concat(firstName, " ").concat(lastName) : undefined;

  var traitsFinal = _objectSpread({
    name: name,
    email: email
  }, traits);

  var isActiveSession = Boolean((0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE));

  if (!userContext.is_guest && objectId && isActiveSession) {
    if (window !== undefined && window.LogRocket) {
      window.LogRocket.identify(objectId, traitsFinal);
    }
  }

  return Promise.resolve(userContext);
}